import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { useScrollAnimations } from '../hooks/useScrollAnimations';
import ScrollToTop from './ScrollToTop';
import FluidCursor from './FluidCursor';
import SchemaMarkup from './SchemaMarkup';

export default function Layout() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { pathname } = location;

  useScrollAnimations();

  useEffect(() => {
    // Only scroll to top on PUSH navigation (explicit link click)
    // On POP navigation (browser Back / Forward), allow native scroll restoration without jump/flash
    if (navigationType !== 'POP') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTo(0, 0);
      document.body.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  useEffect(() => {
    // Dynamic Title Management for SEO
    const baseTitle = 'Prince IT Solution';
    const path = pathname.split('/')[1];
    let pageTitle = '';

    switch (path) {
      case 'about-us':
        pageTitle = 'About Us | Leading Software Development Company';
        break;
      case 'services':
        pageTitle = 'Our Services | Web & Mobile App Development';
        break;
      case 'portfolio':
        pageTitle = 'Portfolio | Our Latest Software Projects';
        break;
      case 'blog':
        pageTitle = 'Blog | IT Insights & Technology Trends';
        break;
      case 'technology':
        pageTitle = 'Technology Stack | Modern Development Tools';
        break;
      case 'contact-us':
        pageTitle = 'Contact Us | Get a Free Project Quote';
        break;
      default:
        pageTitle = 'Web & App Development';
    }

    document.title = `${baseTitle} | ${pageTitle}`;
  }, [pathname]);

  return (
    <div className="theme-shell min-h-screen flex flex-col font-sans">
      <SchemaMarkup />
      <div className="hidden lg:block">
        <FluidCursor />
      </div>
      <Navbar />
      <ScrollToTop />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
